import React from "react";
import {useForm} from "react-hook-form";
import FormProgress from "@/modules/front/ReservationExternal/FormProgress";
import moment from "moment";


const ReservationExternalStep2 = (props) => {
    const {
        register,
        handleSubmit,
        formState: {errors}
    } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    };

    return <>
        <FormProgress
            steps={[window.translations.reservationExternal.steps.personalInfo, window.translations.reservationExternal.steps.summary]}
            currentStep={2}/>
        <h2 className={'h5 mt-3 text-uppercase'}>Rezervace</h2>
        <div className="row">
            <div className={'col-md-12 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Položka:
                    </div>
                    <div>
                        {props.itemTitle}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Vyzvednutí:
                    </div>
                    <div>
                        {moment(props.dateFrom).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Vrácení:
                    </div>
                    <div>
                        {moment(props.dateTo).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
        </div>
        <h2 className={'h5 mt-3 text-uppercase'}>Osobní údaje</h2>
        <div className="row">
            <div className={'col-md-6 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Jméno:
                    </div>
                    <div>
                        {props.personalData.firstname}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-2'}>
                <div className={'bg-light p-3'}>

                    <div className={'fw-bold'}>
                        Příjmení:
                    </div>
                    <div>
                        {props.personalData.lastname}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        E-mail:
                    </div>
                    <div>
                        {props.personalData.email}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Telefon:
                    </div>
                    <div>
                        {props.personalData.phone}
                    </div>
                </div>
            </div>
        </div>

        <div className={'row'}>
            <div className={'col-md-6 mt-3'}>

            </div>
            <div className={'col-md-6 mt-3 text-md-end'}>
                <div className={'pt-3 fs-5'}>
                    Celková cena: {props.totalPrice} Kč
                </div>
            </div>
        </div>

        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={() => props.setStep(1)}><i
                className="fas fa-chevron-left me-3"></i> Upravit údaje</span>
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={props.onSubmit}>Odeslat <i
                className="fas fa-chevron-right ms-3"></i></span>
        </div>
    </>;

};

export default ReservationExternalStep2;